export default "__VITE_ASSET__BpHBCpNI__"